import { all, call, fork, put, takeLatest, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as ReportingRead from '../../Apis/ReportingReadApi';
import * as Actions from './SessionsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import moment from 'moment-timezone';

export function* getSessionsWatcher() {
  yield takeLatest(Actions.GET_SESSIONS_REQUEST, getSessionsWorker);
}

export function* getFilterWatcher() {
  yield takeLatest(Actions.FILTER_SESSIONS_BY_COUNT_REQUEST, filterWorker);
}

export function* getSessionsWorker(action) {
  try {
    let sessions = [];
    let pageNum = 0;
    let hasNextPage = false;
    const { fromTime, toTime, limit } = action.payload;
    do {
      const axiosResponse = yield call(ReportingRead.getSessions, fromTime, toTime, pageNum, limit);
      const apiBody = axiosResponse.data;
      sessions = [...sessions, ...apiBody.data];
      pageNum = apiBody.next;
      hasNextPage = limit === null && apiBody.next;
    } while (hasNextPage);

    yield put({
      type: Actions.GET_SESSIONS_SUCCESS,
      payload: { sessions, limit, fromTime, toTime }
    });

    if (limit) {
      let payload = yield select(getFromAndToTimeFromSessionReducer);
      yield fork(getTrendWorker, { type: Actions.GET_SESSIONS_TRENDS_REQUEST, payload });
    } else {
      let payload = { fromTime: fromTime, toTime: toTime };
      yield fork(getTrendWorker, { type: Actions.GET_SESSIONS_TRENDS_REQUEST, payload });
    }
  } catch (error) {
    yield put({ type: Actions.GET_SESSIONS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export function getFromAndToTimeFromSessionReducer(state) {
  const { fromTime, toTime } = state.reduced_sessions.filter;
  return { fromTime, toTime };
}

function* getTrendWorker(action) {
  try {
    let fromTime = moment(action.payload.fromTime);
    let toTime = moment(action.payload.toTime);
    let range = fromTime.diff(toTime, 'days');
    let previousFromTime, previousToTime;
    let yearDays = moment().isLeapYear() ? 366 : 365;
    let trendResponse;
    if (range <= -364) {
      previousFromTime = moment()
        .subtract(Math.abs(range) * 2, 'd')
        .startOf('d');
      previousToTime = moment()
        .subtract(Math.abs(range) + 1, 'd')
        .endOf('d');
    } else {
      if (range === 0) {
        previousFromTime = moment(fromTime)
          .subtract(1, 'd')
          .startOf('d');
        previousToTime = moment(fromTime)
          .subtract(1, 'd')
          .endOf('d');
      } else if (range < -182) {
        previousFromTime = moment(fromTime)
          .subtract(yearDays - Math.abs(range) - 1, 'd')
          .startOf('d');
        previousToTime = moment(fromTime)
          .subtract(1, 'd')
          .endOf('d');
      } else {
        previousFromTime = moment(fromTime)
          .add(range - 1, 'd')
          .startOf('d');
        previousToTime = moment(fromTime)
          .subtract(1, 'd')
          .endOf('d');
      }
      trendResponse = yield call(
        ReportingRead.getTrendComparisonData,
        previousFromTime.toISOString(),
        previousToTime.toISOString()
      );
    }

    let trend = trendResponse ? trendResponse.data : { totalRegistrants: 'NA', totalAttendees: 'NA' };
    trend.prevDateRange = {
      previousFromTime: previousFromTime.toISOString(),
      previousToTime: previousToTime.toISOString()
    };

    yield put({
      type: Actions.GET_SESSIONS_TRENDS_SUCCESS,
      payload: { trend }
    });
  } catch (error) {
    yield put({ type: Actions.GET_SESSIONS_TRENDS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export function* filterWorker(action) {
  // maybe reduce this delay
  yield call(delay, 20);
  yield put({
    type: Actions.FILTER_SESSIONS_BY_COUNT,
    payload: action.payload
  });
}

export default function* rootSaga() {
  yield all([fork(getSessionsWatcher), fork(getFilterWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/Sessions/SessionsSagas.js